// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const RELATED_WIKI_ARTICLES = "Souvisej\u00edc\u00ed \u010dl\u00e1nky";
